const INITIAL_STATE = {
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
  interval: {},
  popupNotShownAfterLogin: false,
  notificationsEnabled: undefined,
  didInvalidate: true,
};

module.exports = function DailyBoostIntervalReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'FETCH_DAILY_BOOST_INTERVAL_IN_PROGRESS':
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
        fetchPromise: action.fetchPromise,
      };
    case 'FETCH_DAILY_BOOST_INTERVAL_SUCCESSFUL':
      return {
        ...state,
        fetchingInProgressSince: null,
        interval: action.interval,
        lastSuccessfulFetch: action.timestamp,
        fetchPromise: null,
        didInvalidate: false,
      };
    case 'FETCH_DAILY_BOOST_INTERVAL_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
        fetchPromise: null,
      };
    case 'FORCE_SHOWING_POPUP_AFTER_LOGIN':
      return {
        ...state,
        popupNotShownAfterLogin: true,
      };
    case 'SHOWN_POPUP_AFTER_FORCING':
      return {
        ...state,
        popupNotShownAfterLogin: false,
      };
    case 'ENABLE_NOTIFICATIONS':
      return {
        ...state,
        notificationsEnabled: true,
      };
    case 'DISABLE_NOTIFICATIONS':
      return {
        ...state,
        notificationsEnabled: false,
      };
    case 'LOGOUT_SUCCESSFUL':
      return {
        ...state,
        popupNotShownAfterLogin: false,
      };
    default:
      return state;
  }
};
